import {
  ModalComponent,
  createModalsComponent,
} from 'modules/campaigns/lib/contexts/createModalContext';
import { DynamicContentBuilder } from 'modules/dynamicContentBuilder';
import { CreativeLibraryPanel } from 'modules/creativeLibrary';
import {
  CreativeLibraryPanelType,
  ContentModals,
  ContentModalStateType,
  useModalContext as useLegacyModalContext,
} from 'utils/contexts/modal';
import { SavedRowUnsavedChangesModal } from 'modules/dragAndDropEditor/modals/SavedRowUnsavedChangesModal';
import { ModalType, ModalProps, useModalContext } from '../context';
import { ConfirmCustomFontModal } from './ConfirmCustomFontModal';
import { SelectContentEditorModals } from './SelectContentEditorModals/SelectContentEditorModals';
import { useSendTestMsgContext, TestMsgModals } from '../context/SendTestMsgContext';
import { DisplayTestMsgToInternalListModal } from './DisplayTestMsgToInternalListModal';
import { DisplayTestMsgToOtherModal } from './DisplayTestMsgToOtherModal';
import { DisplayTestMsgToYourselfModal } from './DisplayTestMsgToYourselfModal';
import { SendTestMsgAsRandomModal } from './SendTestMsgAsRandomModal';
import { SendTestMsgToInternalListModal } from './SendTestMsgToInternalListModal';
import { SendTestMsgToOtherModal } from './SendTestMsgToOtherModal';

import { CopyTemplateModal } from './CopyTemplateModal';
import { TemplateInsertSnippetModal } from './TemplateInsertSnippetModal';
import { useTemplateQueryContext } from '../context/TemplateQueryContext';
import { WhatsApp } from 'constants/messageMediums';
import { SpamReportModal } from './SpamReportModal';
import { MovableInkPanel } from 'modules/movableInk';

const MODAL_COMPONENTS_MAPPER = {
  [ModalType.ConfirmCustomFontModal]: ConfirmCustomFontModal as ModalComponent<ModalProps>,
  [ModalType.SelectContentEditorModals]: SelectContentEditorModals,
  [ModalType.DynamicContentBuilder]: DynamicContentBuilder as ModalComponent<ModalProps>,
  [ModalType.SavedRowUnsavedChangesModal]:
    SavedRowUnsavedChangesModal as ModalComponent<ModalProps>,
  [ModalType.SpamReport]: SpamReportModal as ModalComponent<ModalProps>,
  [ModalType.MovableInk]: MovableInkPanel as ModalComponent<ModalProps>,
};

export const Modals = createModalsComponent<ModalType, ModalProps>(
  MODAL_COMPONENTS_MAPPER,
  useModalContext,
);

/**
 * NOTE: THE BELOW MODALS WILL BE MIGRATED TO USE THE ABOVE INFRA
 */

export const CommonModals = () => {
  const { hideModal, modalState } = useLegacyModalContext<ContentModalStateType>();
  const { medium } = useTemplateQueryContext();
  const modalStateAM = modalState as CreativeLibraryPanelType;

  return (
    <>
      {/* CopyTemplateModal needs to remain mounted, has internal isVisible indicator */}
      <TemplateInsertSnippetModal />
      <CopyTemplateModal />
      {modalStateAM?.modal === ContentModals.CreativeLibrary && (
        <CreativeLibraryPanel
          hideGifs={medium === WhatsApp}
          onClose={hideModal}
          {...modalStateAM}
        />
      )}
    </>
  );
};

export const SendTestMsgModals = () => {
  const { openTestMsgModal } = useSendTestMsgContext();

  return (
    <>
      {openTestMsgModal === TestMsgModals.SendTestAsRandom && <SendTestMsgAsRandomModal />}
      {openTestMsgModal === TestMsgModals.SendTestToInternalList && (
        <SendTestMsgToInternalListModal />
      )}
      {openTestMsgModal === TestMsgModals.SendTestToOther && <SendTestMsgToOtherModal />}
      {openTestMsgModal === TestMsgModals.DisplayTestToYourself && (
        <DisplayTestMsgToYourselfModal />
      )}
      {openTestMsgModal === TestMsgModals.DisplayTestToInternalList && (
        <DisplayTestMsgToInternalListModal />
      )}
      {openTestMsgModal === TestMsgModals.DisplayTestToOther && <DisplayTestMsgToOtherModal />}
    </>
  );
};
